// Client-side reducers for skill-tier and XP-grant server messages
// (Phase 7 Block E). Extracted from server-message-reducer.ts so that
// file stays under the §10 400-line cap.

import type { SkillEntry } from "./types.ts";

type EventLogLike = { push(text: string, kind: string): void };

export function applySkillTierReached(
  payload: { skillId: string; tier: string; newXp: number },
  skills: SkillEntry[],
  onSkillTierReached: (skillId: string, tier: string) => void,
  eventLog: EventLogLike,
): void {
  const existing = skills.find((s) => s.skillId === payload.skillId);
  if (existing) existing.xp = payload.newXp;
  else skills.push({ skillId: payload.skillId, xp: payload.newXp });
  onSkillTierReached(payload.skillId, payload.tier);
  eventLog.push(`New tier: ${payload.skillId} → ${payload.tier}!`, "xpTier");
}

export function applyXpGranted(
  payload: { skillId: string; xpAdded: number; newTotal: number; tier: string },
  skills: SkillEntry[],
  eventLog: EventLogLike,
): void {
  const entry = skills.find((s) => s.skillId === payload.skillId);
  if (entry) entry.xp = payload.newTotal;
  else skills.push({ skillId: payload.skillId, xp: payload.newTotal });
  eventLog.push(
    `+${Math.round(payload.xpAdded)} ${payload.skillId} XP (${payload.tier}, total: ${Math.round(payload.newTotal)})`,
    "xp",
  );
}
